import { render, staticRenderFns } from "./pixAuditLogModal.vue?vue&type=template&id=2adda058&scoped=true"
import script from "./pixAuditLogModal.vue?vue&type=script&lang=js"
export * from "./pixAuditLogModal.vue?vue&type=script&lang=js"
import style0 from "./pixAuditLogModal.vue?vue&type=style&index=0&id=2adda058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adda058",
  null
  
)

export default component.exports